// ScrollToTopButton.js
import React, { useState, useEffect } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Scroll event listener
  const handleScroll = () => {
    const scrollY = window.scrollY;
    if (scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Attach/detach the scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "2vh",
        right: "5vh",
        backgroundColor: "#5e8fde",
        borderRadius: "50%",
        color: "#fff",
        border: "none",
        padding: "10px",
        cursor: "pointer",
        display: isVisible ? "block" : "none",
        transition: "opacity 0.3s",
      }}
      onClick={scrollToTop}
    >
      <ArrowUpwardIcon style={{ color: "#ffffff" }} />
    </div>
  );
};

export default ScrollToTopButton;
